"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconTruckOutline = function IconTruckOutline(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M2 6a3 3 0 0 1 3-3h6c1.306 0 2.418.835 2.83 2h3.038a3 3 0 0 1 2.572 1.457l1.848 3.078A5 5 0 0 1 22 12.108V15a3 3 0 0 1-2.023 2.837 2.5 2.5 0 1 1-.552-1.932A1 1 0 0 0 20 15v-2.892q0-.054-.002-.108H18.5A2.5 2.5 0 0 1 16 9.5V7h-2v11H8.95a2.5 2.5 0 0 1-4.9 0H4a2 2 0 0 1-2-2zm6.5 10H12V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10h.5c.456-.607 1.182-1 2-1s1.544.393 2 1M8 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11.573-6.936q.125.21.215.436H18.5A1.5 1.5 0 0 1 17 9.5V7.009a1 1 0 0 1 .725.476zM19 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
    clipRule: "evenodd"
  })));
};

export { IconTruckOutline, IconTruckOutline as default };
